import React,{useState} from 'react';
import './OtherItems.css'
import OtherItemsDisplay from './OtherItemsDisplay';


const OtherItems = ({title}) => {
    const [clicked, setclicked] = useState(false);
    return <div className= "otheritems_container">
        <div className="other_container">
        <h2>{title}</h2>  
        <button onClick={()=>{
            setclicked(!clicked) 
        }}>{clicked?'-':'+'}</button>  
        </div><br/>
      {clicked?<OtherItemsDisplay type={title}/>:null}
    
    </div>;
}
 
export default OtherItems;